<template>
    <div class="body-inner">
        <header-landing-component></header-landing-component>
<section>
        <!-- end: Header -->
        <!-- Inspiro Slider -->
        <div id="slider" class="inspiro-slider dots-creative" data-height-xs="360">
            <!-- Slide 2 -->
            <div class="slide kenburns" style="background-image:url('../../assets/images/adobe_bg_banner.jpg');">
                <div class="bg-overlay"></div>
                <div class="container">
                    <div class="slide-captions text-center text-light">
                        <!-- Captions -->
                        <span class="strong">Certificaciones</span>
                        <h1>Adobe Certified Professional<br>
<span style="font-size: 2.55rem">PROGRAM</span></h1>
                        <!-- end: Captions -->
                    </div>
                </div>
            </div>
            <!-- end: Slide 2 -->

        </div>
        <!--end: Inspiro Slider -->



            <div class="container">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="heading-text heading-section">
                            <h2 style="font-size: 2.85rem">LA<span style="color: #EB1000"> CREATIVIDAD</span> ADQUIERE CREDIBILIDAD</h2>

                        </div>
						<img src="../../assets/images/certificaciones/acp.png">
                    </div>
                    <div class="col-lg-8">
                        <div class="row">
                            <div class="col-lg-10">
								
								<strong>Adobe Certified Professional</strong> es la certificación reconocida por la industria que demuestra el dominio de <strong>Adobe Creative Cloud</strong> y el conocimiento indispensable para las carreras de medios digitales.<br>

Cada exmen está integrado con una aplicación de Adobe y diseñado por expertos, permitiendo una evaluación real de las habilidades rqueridas para entrar al mundo laboral.
								<hr>
								<br>
								
								<h4>BENEFICIOS DE LA CERTIFICACIÓN</h4>
								
								<ul class="list-icon list-icon-check">
									<li>Otorga a los estudiantes instinto creativo y credibilidad. La certificación es una herramienta efectiva para demostrar la capacidad de utilizar medios digitales necesarios para planificar, diseñar, construir y mantener comunicaciones efectivas.</li>

<li>Aumenta la confianza de los profesores con habilidades efectivas. Mejoran sus credenciales de enseñanza mediante la obtención de una certificación reconocida a nivel mundial.</li>

<li>La certificación ayuda a demostrar aptitud. En un mundo laboral cada vez más competitivo, las empresas no sólo necesitan que los empleados estén familiarizados con la tecnología digital para impulsar resultados exitosos para la empresa, necesitan empleados competentes.</li>
								
								</ul>
							
							
							</div>

                         

                        </div>
                    </div>

                </div>
                <div class="row mt-5">
                    <div class="col-12 text-center">
                        <p class="gca-title-big">CERTIFICADO OFICIAL</p>
                    </div>
                    <div class="col-12 text-center">
                        <img src="../../assets/images/carousel/Adobe_Certified_Professional_Certificate.png" alt="">
                    </div>
                </div>
            </div>
        </section>


        <section class="section-fullwidth text-light p-b-0">
            <div class="row">
                
              <img src="../../assets/images/certificaciones-adobe.jpg" class="img-fluid">

               
            </div>
        </section>

        <!--call-to-action dark -->
        <div class="call-to-action p-t-100 p-b-100  mb-0 call-to-action-dark">
            <div class="container">
                <div class="row">
                    <div class="col-lg-10">
                        <h3>
                            ¿Quieres agregar esta credencial con validez internacional a tu CV?
                        </h3>
                        <p>
                            Conoce todas las soluciones que Global Certification Academy ofrece para agregar VALOR A TU CURRÍCULUM.
                        </p>
                    </div>
                    <div class="col-lg-2"><router-link class="btn btn-primary btn-lg" to="/register">INSCRIBIRME</router-link></div>
                </div>
            </div>
        </div>
        <!--end: call-to-action dark -->
        <LeadComponent></LeadComponent>
        <footer-landing-component></footer-landing-component>
    </div>
</template>

<script>
  import HeaderLandingComponent from "../../components/Landing/HeaderLandingComponent.vue"
  import FooterLandingComponent from "../../components/Landing/FooterLandingComponent.vue"
  import LeadComponent from "../../components/Landing/LeadComponent.vue"
	export default {
		components: {
			HeaderLandingComponent,
            FooterLandingComponent,
            LeadComponent
		},            
		name: 'adobe',
		data() {
			return {
            }
        },
		methods: {
        },
		mounted() {
            const plugin = document.createElement("script");
            plugin.setAttribute(
            "src",
            "../../assets/js/functions.js"
            );
            plugin.async = true;
            document.head.appendChild(plugin);            
        }        
    }

</script>